<div class="upload-container">
  <div
    class="upload-box"
    (click)="triggerFileInput()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [class.drag-over]="isDragOver"
  >
    <ng-container *ngIf="!previewUrl">
      Arrastra o haz clic para subir tu firma
    </ng-container>
    <ng-container *ngIf="previewUrl">
      Haz clic o arrastra para reemplazar tu firma
    </ng-container>
  </div>

  <div *ngIf="previewUrl" class="preview">
    <img [src]="previewUrl" alt="Vista previa" />
  </div>

  <input
    #fileInput
    type="file"
    style="display: none"
    [attr.accept]="allowedTypes.length ? allowedTypes.join(',') : null"
    (change)="onFileChange($event)"
  />
</div>
